// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Mi2u2","content":"RecentSearches_content__2jm9m"};